import { MOUSE } from 'three';

export const EPS = 0.001;
export enum STATE {
  'NONE' = -1,
  'ROTATE',
  'ZOOM',
  'MOVE',
  'TOUCH_ROTATE',
  'TOUCH_ZOOM',
  'TOUCH_MOVE'
};

export const MOVEMODE: CameraMoveMode = Object.freeze({
  normal: {
    mouse: {
      rotate: MOUSE.LEFT,
      zoom: MOUSE.MIDDLE,
      move: MOUSE.RIGHT
    },
    touch: {
      rotate: 1,
      zoom: 2,
      move: -1
    }
  },
  inversed: {
    mouse: {
      rotate: MOUSE.RIGHT,
      zoom: MOUSE.MIDDLE,
      move: MOUSE.LEFT
    },
    touch: {
      rotate: -1,
      zoom: 2,
      move: 1
    }
  }
});

export interface CameraMoveMode {
  normal: MoveMode,
  inversed: MoveMode
}

export interface MoveMode {
  mouse: MoveMouseMode,
  touch: MoveTouchMode
}

interface MoveMouseMode {
  rotate: MOUSE;
  zoom: MOUSE;
  move: MOUSE;
}

interface MoveTouchMode {
  rotate: number,
  zoom: number,
  move: number
}
